/**
 * The sign-in step's standard look (the prototype's checkout sign-in block).
 * Draws the behavior half's state and calls its actions; holds no rule.
 */
import { partsOf, pieceRoot } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import type { SignInStepRuntime } from './useSignInStep';
import css from './SignInStep.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function SignInStepView({ state, actions }: SignInStepRuntime) {
  return (
    <div className={css.signin} {...pieceRoot(contract)} {...part('step')}>
      {state.welcomeBack && (
        <p className={css.welcome} role="status" {...part('welcomeBack')}>
          Welcome back. Your pick is still here.
        </p>
      )}
      <p className={css.lead} {...part('lead')}>
        Your booking, reminders and messages from {state.studioName} arrive in Telegram.
      </p>
      <button
        type="button"
        className={`${shared.btn} ${css.btnTg}`}
        disabled={!state.ready || state.attempt === 'pending'}
        onClick={actions.signIn}
        {...part('signIn', (!state.ready || state.attempt === 'pending') && 'disabled')}
      >
        <Icon name="tg" />
        Sign in with Telegram
      </button>
      {actions.signInAsTestAccount && (
        <button
          type="button"
          className={`${shared.btn} ${shared.btnOutline}`}
          disabled={state.attempt === 'pending'}
          onClick={actions.signInAsTestAccount}
          {...part('testAccount')}
        >
          Sign in as test account
        </button>
      )}
      {(state.attempt === 'error' || state.attempt === 'unavailable') && (
        <p className={css.error} role="alert" {...part('error')}>
          {state.attempt === 'unavailable' ? 'Sign in is not open at this studio yet.' : 'Sign in did not go through. Please try again.'}
        </p>
      )}
      <p className={css.noTg} {...part('noTelegram')}>
        <b>No Telegram yet?</b> Get it on the{' '}
        <a
          href={state.storeLinks.appStore}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => actions.leftToGetTelegram('appStore')}
          {...part('appStore')}
        >
          App Store
        </a>{' '}
        or{' '}
        <a
          href={state.storeLinks.googlePlay}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => actions.leftToGetTelegram('googlePlay')}
          {...part('googlePlay')}
        >
          Google Play
        </a>
        , then come back here to finish.
      </p>
    </div>
  );
}
